import Vue from 'vue'
import Utils from './utils';

Vue.filter('currency', function (value) {
    return Utils.setCurrencyFormat(value);
});

Vue.filter('percent', function (value) {
    return Utils.setPercentFormat(value);
});

Vue.filter('integer', function (value) {
    return Utils.setIntegerFormat(value);
});

Vue.filter('decimal', function (value) {
    return Utils.setDecimalFormat(value);
});

Vue.filter('date', function (value) {
    return Utils.setDateFormatITA(value);
});
